import To from 'await-to-js'
import Callback from '@/services/Callback'
import { wizStandardInstance } from './instance'

export default class ThreeDimensionsService {
  static async getPipeLineList(payload) {
    const [err, res] = await To(
      wizStandardInstance.post('/api/three-dimensions/get-pipe-line-list-async', payload)
    )
    return Callback(err, res)
  }
}
